<script>
  // Progressive enhancement over ApplicationHelper#searchable_table: the rows
  // and the "no matching records" row are server-rendered inside the enclosing
  // [data-search-scope], and this island only owns the search box and decides
  // which of them are hidden. Nothing here re-renders the table.
  let { placeholder = "Search… (press / to focus)" } = $props()

  let root = $state()
  let input = $state()
  let query = $state("")

  function clear() {
    query = ""
    input.focus()
  }

  // "/" is only a shortcut while the visitor is not already typing somewhere.
  function editingText() {
    const tag = document.activeElement?.tagName
    return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT"
  }

  $effect(() => {
    const needle = query.toLowerCase().trim()
    const scope = root.closest("[data-search-scope]")
    if (!scope) return

    let matches = 0
    for (const row of scope.querySelectorAll("[data-search-text]")) {
      const hit = !needle || row.dataset.searchText.toLowerCase().includes(needle)
      row.hidden = !hit
      if (hit) matches += 1
    }

    const empty = scope.querySelector("[data-search-empty]")
    if (empty) empty.hidden = matches > 0
  })

  $effect(() => {
    function handleKeydown(event) {
      if (event.key === "/" && !editingText()) {
        event.preventDefault()
        input.focus()
      } else if (event.key === "Escape" && document.activeElement === input) {
        query = ""
        input.blur()
      }
    }

    document.addEventListener("keydown", handleKeydown)
    return () => document.removeEventListener("keydown", handleKeydown)
  })
</script>

<div class="search-container" bind:this={root}>
  <input
    type="text"
    id="search"
    name="search"
    class="input search-input"
    {placeholder}
    autocomplete="off"
    bind:value={query}
    bind:this={input}
  />
  <button
    type="button"
    class="delete search-clear"
    aria-label="Clear search"
    hidden={!query}
    onclick={clear}
  ></button>
</div>

<style>
  .search-container {
    position: relative;
    margin-bottom: 1rem;
  }

  /* Room for the clear button overlaid on the input's right edge. */
  input {
    padding-right: 2.5rem;
  }

  .search-clear {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
